module.exports = __webpack_public_path__ + "img/7@3x.c3282394.png";